import React, { useState } from 'react';
import { EmailButton } from './ResendEmailButton';
import { candidatesApi } from '../../api/candidates';
import { useLanguage } from '../../contexts/LanguageContext';

interface SendEmailButtonProps {
  candidateId: string;
  className?: string;
  disabled?: boolean;
  email?: string;
}

const SendEmailButton = ({ candidateId, className, disabled = false, email = "" }: SendEmailButtonProps) => {
  const { t } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);

  const handleSendEmail = async () => {
    if (disabled) return;
    try {
      setIsLoading(true);
      await candidatesApi.sendEmail(candidateId);
    } catch (error) {
      console.error('Failed to send email:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <EmailButton
      onSend={handleSendEmail}
      className={className}
      isLoading={isLoading}
      disabled={disabled}
      email={email}
      label={t('candidates.email.send')}
      title={t('candidates.email.title')}
    />
  );
};

export default SendEmailButton;